export const appConfig = {
    name: "Виртуоз",
    version: "1.0.0",
    apiUrl: process.env.REACT_APP_API_URL || "https://89.105.223.210:8000/api",
    defaultLanguage: "ru",
    supportedLanguages: ["ru", "en"],
    defaultTheme: "light",
    themes: ["light", "dark"],
    socialLinks: {
        telegramChannel: process.env.REACT_APP_TELEGRAM_CHANNEL || "https://t.me/your_channel",
        telegramCommunity: process.env.REACT_APP_TELEGRAM_COMMUNITY || "https://t.me/VirtuosChat",
    },
    // Ссылки на бота поддержки — единый источник для сайдбара, FAQ и заглушки
    // TelegramStartGate. Реальный бот — `virtuos_help_bot` (а не `virtuos_help`).
    supportBots: {
        telegram: "https://t.me/virtuos_help_bot",
        max: "https://max.ru/id550367227555_3_bot",
    },
};
